// Ingresso dei telefoni: il telefono nuovo chiede di entrare, la responsabile approva e sceglie i ruoli.
import {
  collection, doc, setDoc, writeBatch, onSnapshot, serverTimestamp, deleteDoc,
} from 'firebase/firestore';

export const RUOLI = Object.freeze(['responsabile', 'operatrice', 'ricevimento', 'dev']);

/** Codice corto del telefono: si legge a voce alla responsabile per riconoscere la richiesta. */
export function codiceTelefono(uid) {
  return uid.slice(-6).toUpperCase();
}

export function ascoltaDispositivo({ db, sid, uid }, quando, errore) {
  return onSnapshot(doc(db, `strutture/${sid}/dispositivi/${uid}`), (d) => quando(d.exists() ? d.data() : null), errore);
}

export function inviaRichiesta({ db, sid, uid }, { nome, lingua }) {
  return setDoc(doc(db, `strutture/${sid}/richieste/${uid}`), {
    nome: String(nome).trim().slice(0, 40),
    lingua,
    codice: codiceTelefono(uid),
    quando: serverTimestamp(),
  });
}

export function ascoltaRichieste({ db, sid }, quando, errore) {
  return onSnapshot(collection(db, `strutture/${sid}/richieste`), (s) => quando(s.docs.map((d) => ({ uid: d.id, ...d.data() }))), errore);
}

/**
 * La responsabile approva un telefono. `op` (op1…op3) collega il telefono di un'operatrice alla sua colonna.
 */
export function approva({ db, sid, uid: chi }, richiesta, ruoli, op = null) {
  const b = writeBatch(db);
  b.set(doc(db, `strutture/${sid}/dispositivi/${richiesta.uid}`), {
    nome: richiesta.nome,
    lingua: richiesta.lingua || 'it',
    ruoli: ruoli.filter((r) => RUOLI.includes(r)),
    attivo: true,
    ...(op && { op }),
    approvatoDa: chi,
    approvato: serverTimestamp(),
  });
  b.delete(doc(db, `strutture/${sid}/richieste/${richiesta.uid}`));
  return b.commit();
}

// Un telefono già attivo toglie la sua vecchia richiesta (es. attivato a mano dalla console).
export function togliMiaRichiesta({ db, sid, uid }) {
  return deleteDoc(doc(db, `strutture/${sid}/richieste/${uid}`));
}

export function rifiuta({ db, sid }, richiesta) {
  return deleteDoc(doc(db, `strutture/${sid}/richieste/${richiesta.uid}`));
}
